"use client";

import { BookMenuContext } from "@/context/bookMenuContext";
import styles from "@/styles/modules/components/header/bookMenu.module.scss";
import Image from "next/image";
import { useContext } from "react";
import BookMenuBedrooms from "./bookMenuOptions/BookMenuBedrooms";
import BookMenuMeetingsEvents from "./bookMenuOptions/BookMenuMeetingsEvents";
import BookMenuEatDrink from "./bookMenuOptions/BookMenuEatDrink";
import { Restaurant, Room } from "@/types/wordpress";
import { translate } from "@/utils/translate";
import { LanguageContext } from "@/context/languageContext";

interface BookMenuProps {
  restaurants: Restaurant[];
}

export default function BookMenu({ restaurants }: BookMenuProps) {
  const { language } = useContext(LanguageContext);
  const { isBookMenuOpen, closeBookMenu, currentBookMenu, setCurrentBookMenu } =
    useContext(BookMenuContext);

  return (
    <section
      className={`${styles.bookMenu} ${isBookMenuOpen ? styles.opened : ""}`}
    >
      <div className={styles.closer}>
        <Image
          src="/icons/close-icon.svg"
          alt="Close menu icon"
          width="41"
          height="31"
          onClick={closeBookMenu}
        />
      </div>
      <div className={styles.tabSelector}>
        <span
          className={`${currentBookMenu === 1 ? styles.current : ""}`}
          onClick={() => setCurrentBookMenu(1)}
        >
          {translate["bedrooms"][language]}
        </span>
        <span
          className={`${currentBookMenu === 2 ? styles.current : ""}`}
          onClick={() => setCurrentBookMenu(2)}
        >
          {translate["meetingsAndEvents"][language]}
        </span>
        <a href="https://www.sevenrooms.com/reservations/elstarviese/more-cravings-app" target="_blank"
        >
          {translate["eatAndDrink"][language]}
        </a>
      </div>
      <div
        className={`${styles.form} ${
          currentBookMenu === 1 ? styles.active : ""
        }`}
      >
        <BookMenuBedrooms />
      </div>
      <div
        className={`${styles.form} ${
          currentBookMenu === 2 ? styles.active : ""
        }`}
      >
        <BookMenuMeetingsEvents />
      </div>
      <div
        className={`${styles.form} ${
          currentBookMenu === 3 ? styles.active : ""
        }`}
      >
        <BookMenuEatDrink restaurants={restaurants} />
      </div>
    </section>
  );
}
